import { DEALERS_OBJECT_STORE_NAME } from '../constants'

export function upgradeToV2(db: IDBDatabase) {
  db.createObjectStore(DEALERS_OBJECT_STORE_NAME, {
    keyPath: 'id'
  })
}
